export function arrayAny<T>(arr: readonly T[] | null | undefined,
                            predicate?: (t: T) => boolean): boolean {
  if (!Array.isArray(arr) || arr.length === 0)
    return false;
  if (typeof predicate !== 'function')
    return true;
  for (let t of arr)
    if (predicate(t))
      return true;
  return false;
}
